<div class="row">
    <div class="col-1">
        <app-back-button></app-back-button>
    </div>
    <div class="col">
        <h2 class="h2-responsive text-center">New Question Set</h2>
    </div>
</div>
    <div class="row">
    <div class="col">
        <div class="card card-cascade narrower">
            <div class="view gradient-card-header primary-gradient white-text">
                <h3 class='h3-responsive text-center'>{{questionSet.title}}</h3>
            </div>
            <div class="card-body">
                <app-question-set-core-form [questionSet]="questionSet"></app-question-set-core-form>
                <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/question-set-new/question-set-new.component.html